import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { addressAPI, authAPI } from '../api/services';
import toast from 'react-hot-toast';
import { FiUser, FiMapPin, FiLock, FiTrash2 } from 'react-icons/fi';
import './Account.css';

export default function Account() {
  const { user } = useAuth();
  const [tab, setTab] = useState('profile');
  const [addresses, setAddresses] = useState([]);
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

  useEffect(() => {
    addressAPI.getAll().then(res => setAddresses(res.data.data || [])).catch(() => {});
  }, []);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirmPassword) { toast.error('Passwords do not match'); return; }
    if (pwForm.newPassword.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    try {
      await authAPI.changePassword({ currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword });
      toast.success('Password updated');
      setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    }
  };

  const handleDeleteAddress = async (id) => {
    try {
      await addressAPI.remove(id);
      setAddresses(prev => prev.filter(a => a.id !== id));
      toast.success('Address deleted');
    } catch (err) {
      toast.error('Failed to delete');
    }
  };

  return (
    <div className="account-page">
      <div className="account-sidebar">
        <h2>My Account</h2>
        <nav>
          <button className={tab === 'profile' ? 'active' : ''} onClick={() => setTab('profile')}><FiUser /> Profile</button>
          <button className={tab === 'addresses' ? 'active' : ''} onClick={() => setTab('addresses')}><FiMapPin /> Addresses</button>
          <button className={tab === 'password' ? 'active' : ''} onClick={() => setTab('password')}><FiLock /> Password</button>
        </nav>
      </div>
      <div className="account-content">
        {tab === 'profile' && (
          <div className="account-section">
            <h3>Profile Information</h3>
            <div className="profile-info">
              <p><strong>Name:</strong> {user?.firstName} {user?.lastName}</p>
              <p><strong>Email:</strong> {user?.email}</p>
              <p><strong>Phone:</strong> {user?.phone || 'Not set'}</p>
            </div>
          </div>
        )}
        {tab === 'addresses' && (
          <div className="account-section">
            <h3>Saved Addresses</h3>
            {addresses.length === 0 ? <p className="no-data">No addresses saved</p> : (
              <div className="address-grid">
                {addresses.map(a => (
                  <div key={a.id} className="addr-card">
                    <strong>{a.fullName}</strong>
                    <p>{a.addressLine1}{a.addressLine2 && `, ${a.addressLine2}`}</p>
                    <p>{a.city}, {a.state} - {a.postalCode}</p>
                    <p>{a.phone}</p>
                    {a.isDefault && <span className="badge">Default</span>}
                    <button className="addr-delete" onClick={() => handleDeleteAddress(a.id)}><FiTrash2 /></button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {tab === 'password' && (
          <div className="account-section">
            <h3>Change Password</h3>
            <form className="pw-form" onSubmit={handleChangePassword}>
              <div className="form-group">
                <label>Current Password</label>
                <input type="password" required value={pwForm.currentPassword} onChange={e => setPwForm(f => ({ ...f, currentPassword: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>New Password</label>
                <input type="password" required value={pwForm.newPassword} onChange={e => setPwForm(f => ({ ...f, newPassword: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Confirm New Password</label>
                <input type="password" required value={pwForm.confirmPassword} onChange={e => setPwForm(f => ({ ...f, confirmPassword: e.target.value }))} />
              </div>
              <button type="submit" className="btn btn-primary">Update Password</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
